import generateValidationMarkup from "@utils/validation-markup-generator";

export function showValidationErrorsModal(
    {
        validationResult = []
    }
) {

    if(typeof ModalManager === "undefined") {
        alert('ModalManager not loaded');
        return;
    }

    if(!Array.isArray(validationResult)) {
        alert('validationResult must be an array data type');
        return;
    }

    ModalManager.instance.addModal({
        transitionDuration : 10,
        width : {
            value: 60,
            unit : 'vw'
        },
        maxWidth : {
            value: 90,
            unit : 'vw'
        },
        autoHeight : true,
        maxHeight : {
          value: 90,
          unit : 'vh'
        },
        body: {
            content: generateValidationMarkup(validationResult),
            inlineStyles: "padding: 2rem;",
        },
        onShow: function () {

            let _this = this;

            let modal = document.getElementById(this.getModalId());

            if (modal) {

                modal.addEventListener('click', (event) => {

                    event.preventDefault();

                    if (event.target.classList.contains('scroller')) {
                        let target = event.target.getAttribute('data-target');

                        //target = target.replaceAll('.', '\\.');

                        const escapedSelector = target.replace(/(\[data-block=)([^\]]+)(\])/, (match, prefix, value, suffix) => {
                            // `match` is the full matched string: "[data-block=drivers.0.name]"
                            // `prefix` is the first captured group: "[data-block="
                            // `value` is the second captured group: "drivers.0.name"
                            // `suffix` is the third captured group: "]"

                            const escapedValue = CSS.escape(value);

                            return prefix + escapedValue + suffix;
                        });

                        let targetBlock = document.querySelector(
                            escapedSelector
                        );

                        if (targetBlock) {
                            /*targetBlock.scrollIntoView({
                                behavior: "smooth"
                            });*/

                            const scrollPosition= targetBlock.offsetTop - 150;

                            window.scrollTo({
                                top: scrollPosition,
                                behavior: 'smooth'
                            });

                            targetBlock.classList.add('focus-outline');

                            setTimeout(() => {
                                targetBlock.classList.remove('focus-outline');
                            }, 4000);
                        }

                        _this.hide();

                    }
                });

            } else {
                alert('Modal not found');
            }

        },

        header : {
            enabled : true,
            title : 'Fix the following errors',
            cssClass : 'text-danger',
        },
        footer : {
            enabled : true,
            content : `<span class="fs-5 text-info">Note: Click on any message to scroll to the field.</span>`,
            mode : 'custom'
        }
    });

}